export default __webpack_public_path__ + "static/og-image-cal-1f39cae979547327cc24062e80a5ce2d.jpg";